// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset and Base Styles */
.homepage {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  line-height: 1.6;
  color: #333;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Navigation */
.navbar {
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
}

.nav-logo {
  font-size: 1.5rem;
  font-weight: bold;
  color: #333;
}

.login-button {
  background: none;
  border: 1px solid #ddd;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: all 0.2s ease;
}

.login-button:hover {
  background: #f8f9fa;
  border-color: #bbb;
}

/* Hero Section */
.hero {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding-top: 60px;
  background: white;
  position: relative;
}

.hero-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 40px 60px;
  max-width: 800px;
}

.hero-title {
  font-size: 4rem;
  font-weight: bold;
  margin: 0 0 0.5rem 0;
  color: #333;
  line-height: 1.1;
}

.hero-subtitle {
  font-size: 2.5rem;
  font-weight: 300;
  font-style: italic;
  margin: 0 0 1.5rem 0;
  color: #666;
  line-height: 1.2;
}

.hero-description {
  font-size: 1.1rem;
  margin: 0 0 2rem 0;
  color: #666;
  line-height: 1.5;
}

.cta-button {
  background: #333;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
}

.cta-button:hover {
  background: #555;
  transform: translateY(-1px);
}

.cta-button.large {
  padding: 16px 32px;
  font-size: 18px;
}

.arrow {
  transition: transform 0.2s ease;
}

.cta-button:hover .arrow {
  transform: translateX(4px);
}

.section-cta-button {
  background: #333;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 3rem;
  display: inline-block;
  transition: all 0.2s ease;
  font-weight: 500;
}

.section-cta-button:hover {
  background: #555;
  transform: translateY(-1px);
}



/* Section Styles */
section {
  padding: 80px 0;
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  font-weight: bold;
  margin: 0 0 3rem 0;
  color: #333;
}

/* How It Works */
.how-it-works {
  background: 
    linear-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)),
    var(--map-background);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  text-align: center;
}

.steps {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
}

.step {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.step:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
}

.step-number {
  width: 60px;
  height: 60px;
  background: #333;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0 auto 1.5rem;
}

.step-title {
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
  color: #333;
}

.step-description {
  font-size: 1rem;
  color: #666;
  margin: 0;
  line-height: 1.5;
}

/* The PopMates Approach */
.approach {
  background: white;
}

.approach-items {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
}

.approach-item {
  text-align: center;
  padding: 2rem 1rem;
}

.approach-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.approach-item h3 {
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
  color: #333;
}

.approach-item p {
  font-size: 1rem;
  color: #666;
  margin: 0;
  line-height: 1.5;
}

/* Why People Use It */
.why-people-use {
  background: 
    linear-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)),
    var(--map-background);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  text-align: center;
}

.reasons {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  margin-top: 2rem;
}

.reason-card {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.reason-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
}

.reason-card h3 {
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
  color: #333;
}

.reason-card p {
  font-size: 1rem;
  color: #666;
  margin: 0;
  line-height: 1.5;
}

/* About Section */
.about {
  background: white;
  text-align: center;
}

.about-text {
  font-size: 1.5rem;
  font-style: italic;
  color: #666;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
}

/* Testimonial */
.testimonial {
  background: #333;
  text-align: center;
}

.testimonial-quote {
  font-size: 1.3rem;
  font-style: italic;
  color: #e9ecef;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
  border: none;
  padding: 0;
  position: relative;
}



/* Final CTA */
.final-cta {
  background: white;
  text-align: center;
}

.cta-title {
  font-size: 2.5rem;
  font-weight: bold;
  margin: 0 0 2rem 0;
  color: #333;
  line-height: 1.3;
}

/* Responsive Design */
@media (max-width: 768px) {
  .hero-content {
    max-width: 100%;
    padding: 40px 20px;
  }
  
  .hero-title {
    font-size: 2.5rem;
  }
  
  .hero-subtitle {
    font-size: 1.8rem;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .cta-title {
    font-size: 1.8rem;
  }
  
  .steps {
    grid-template-columns: 1fr;
  }
  
  .approach-items {
    grid-template-columns: 1fr;
  }
  
  .reasons {
    grid-template-columns: 1fr;
  }
  
  section {
    padding: 60px 0;
  }
  
  .nav-container {
    padding: 0 15px;
  }
  
  .container {
    padding: 0 15px;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 2rem;
  }
  
  .hero-subtitle {
    font-size: 1.5rem;
  }
  
  .section-title {
    font-size: 1.8rem;
  }
  
  .cta-title {
    font-size: 1.5rem;
  }
  
  .about-text {
    font-size: 1.2rem;
  }
  
  .testimonial-quote {
    font-size: 1.1rem;
  }
  
  section {
    padding: 40px 0;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Homepage.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE;;cAEY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,yCAAyC;EACzC,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;;;AAIA,mBAAmB;AACnB;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE;;yBAEuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;;yBAEuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;;;AAIA,cAAc;AACd;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Reset and Base Styles */\n.homepage {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  line-height: 1.6;\n  color: #333;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n/* Navigation */\n.navbar {\n  background: white;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 100;\n}\n\n.nav-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 60px;\n}\n\n.nav-logo {\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: #333;\n}\n\n.login-button {\n  background: none;\n  border: 1px solid #ddd;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #333;\n  transition: all 0.2s ease;\n}\n\n.login-button:hover {\n  background: #f8f9fa;\n  border-color: #bbb;\n}\n\n/* Hero Section */\n.hero {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  padding-top: 60px;\n  background: white;\n  position: relative;\n}\n\n.hero-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 40px 60px;\n  max-width: 800px;\n}\n\n.hero-title {\n  font-size: 4rem;\n  font-weight: bold;\n  margin: 0 0 0.5rem 0;\n  color: #333;\n  line-height: 1.1;\n}\n\n.hero-subtitle {\n  font-size: 2.5rem;\n  font-weight: 300;\n  font-style: italic;\n  margin: 0 0 1.5rem 0;\n  color: #666;\n  line-height: 1.2;\n}\n\n.hero-description {\n  font-size: 1.1rem;\n  margin: 0 0 2rem 0;\n  color: #666;\n  line-height: 1.5;\n}\n\n.cta-button {\n  background: #333;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-size: 16px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.2s ease;\n}\n\n.cta-button:hover {\n  background: #555;\n  transform: translateY(-1px);\n}\n\n.cta-button.large {\n  padding: 16px 32px;\n  font-size: 18px;\n}\n\n.arrow {\n  transition: transform 0.2s ease;\n}\n\n.cta-button:hover .arrow {\n  transform: translateX(4px);\n}\n\n.section-cta-button {\n  background: #333;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-size: 16px;\n  cursor: pointer;\n  margin-top: 3rem;\n  display: inline-block;\n  transition: all 0.2s ease;\n  font-weight: 500;\n}\n\n.section-cta-button:hover {\n  background: #555;\n  transform: translateY(-1px);\n}\n\n\n\n/* Section Styles */\nsection {\n  padding: 80px 0;\n}\n\n.section-title {\n  text-align: center;\n  font-size: 2.5rem;\n  font-weight: bold;\n  margin: 0 0 3rem 0;\n  color: #333;\n}\n\n/* How It Works */\n.how-it-works {\n  background: \n    linear-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)),\n    var(--map-background);\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  position: relative;\n  text-align: center;\n}\n\n.steps {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem;\n  margin-top: 2rem;\n}\n\n.step {\n  background: white;\n  padding: 2rem;\n  border-radius: 12px;\n  text-align: center;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.step:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);\n}\n\n.step-number {\n  width: 60px;\n  height: 60px;\n  background: #333;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin: 0 auto 1.5rem;\n}\n\n.step-title {\n  font-size: 1.3rem;\n  font-weight: 600;\n  margin: 0 0 1rem 0;\n  color: #333;\n}\n\n.step-description {\n  font-size: 1rem;\n  color: #666;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* The PopMates Approach */\n.approach {\n  background: white;\n}\n\n.approach-items {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem;\n  margin-top: 2rem;\n}\n\n.approach-item {\n  text-align: center;\n  padding: 2rem 1rem;\n}\n\n.approach-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n}\n\n.approach-item h3 {\n  font-size: 1.3rem;\n  font-weight: 600;\n  margin: 0 0 1rem 0;\n  color: #333;\n}\n\n.approach-item p {\n  font-size: 1rem;\n  color: #666;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Why People Use It */\n.why-people-use {\n  background: \n    linear-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)),\n    var(--map-background);\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  position: relative;\n  text-align: center;\n}\n\n.reasons {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1.5rem;\n  margin-top: 2rem;\n}\n\n.reason-card {\n  background: white;\n  padding: 2rem;\n  border-radius: 12px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.reason-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);\n}\n\n.reason-card h3 {\n  font-size: 1.3rem;\n  font-weight: 600;\n  margin: 0 0 1rem 0;\n  color: #333;\n}\n\n.reason-card p {\n  font-size: 1rem;\n  color: #666;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* About Section */\n.about {\n  background: white;\n  text-align: center;\n}\n\n.about-text {\n  font-size: 1.5rem;\n  font-style: italic;\n  color: #666;\n  max-width: 800px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n/* Testimonial */\n.testimonial {\n  background: #333;\n  text-align: center;\n}\n\n.testimonial-quote {\n  font-size: 1.3rem;\n  font-style: italic;\n  color: #e9ecef;\n  max-width: 800px;\n  margin: 0 auto;\n  line-height: 1.6;\n  border: none;\n  padding: 0;\n  position: relative;\n}\n\n\n\n/* Final CTA */\n.final-cta {\n  background: white;\n  text-align: center;\n}\n\n.cta-title {\n  font-size: 2.5rem;\n  font-weight: bold;\n  margin: 0 0 2rem 0;\n  color: #333;\n  line-height: 1.3;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .hero-content {\n    max-width: 100%;\n    padding: 40px 20px;\n  }\n  \n  .hero-title {\n    font-size: 2.5rem;\n  }\n  \n  .hero-subtitle {\n    font-size: 1.8rem;\n  }\n  \n  .section-title {\n    font-size: 2rem;\n  }\n  \n  .cta-title {\n    font-size: 1.8rem;\n  }\n  \n  .steps {\n    grid-template-columns: 1fr;\n  }\n  \n  .approach-items {\n    grid-template-columns: 1fr;\n  }\n  \n  .reasons {\n    grid-template-columns: 1fr;\n  }\n  \n  section {\n    padding: 60px 0;\n  }\n  \n  .nav-container {\n    padding: 0 15px;\n  }\n  \n  .container {\n    padding: 0 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero-title {\n    font-size: 2rem;\n  }\n  \n  .hero-subtitle {\n    font-size: 1.5rem;\n  }\n  \n  .section-title {\n    font-size: 1.8rem;\n  }\n  \n  .cta-title {\n    font-size: 1.5rem;\n  }\n  \n  .about-text {\n    font-size: 1.2rem;\n  }\n  \n  .testimonial-quote {\n    font-size: 1.1rem;\n  }\n  \n  section {\n    padding: 40px 0;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
